export default __webpack_public_path__ + "static/media/auction.a6801412.jpeg";